import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import Lottie from 'lottie-react';

// Centered loader wrapper for XVSLottie
export const NanoLoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
//   background-color: #f8f9fa;
background-color: transparent;
  z-index: 9999;
`;

// Hexagonal icon container
export const NanoHexagonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
`;

// Individual hexagon
export const NanoHexagon = styled.div`
  width: 60px;
  height: 60px;
  background: ${props => props.active ? 'linear-gradient(135deg, #0E4C88 0%, #10B981 100%)' : '#e5e7eb'};
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  svg {
    width: 24px;
    height: 24px;
    color: ${props => props.active ? 'white' : '#6b7280'};
  }
`;

// Progress bar container
export const NanoProgressContainer = styled.div`
  margin-top: 40px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

// Lottie card container
export const NanoLottieCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  min-width: 300px;
`;

// Progress bar
export const NanoProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`;

// Progress fill
export const NanoProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #0E4C88 0%, #10B981 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
  width: ${props => props.progress || 33}%;
`;

// Connection status text
export const NanoConnectionText = styled.div`
  background: white;
  border-radius: 8px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 14px;
  color: #374151;
`;

// Radio button indicator
export const NanoRadioButton = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid #0E4C88;
  border-radius: 50%;
  background: transparent;
`;

// Centered XVSLottie component for NanoDashboard
export const NanoXVSLottie = styled(Lottie)`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 600px;
  max-height: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &.dashboard-loader {
    max-width: 500px;
    max-height: 500px;
  }
  
  &.loading-files {
    max-width: 450px;
    max-height: 450px;
  }
  
  &.nano-loader {
    max-width: 600px;
    max-height: 600px;
  }
`;

// Container for the main dashboard content
export const NanoDashboardContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  font-family: 'Inter', system-ui, sans-serif;
`;

// Header section styling
export const NanoDashboardHeader = styled.div`
  padding: 24px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
`;

// Content section styling
export const NanoDashboardContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Page header styling
export const NanoPageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const NanoPageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  font-family: 'Inter', system-ui, sans-serif;
`;

export const NanoPageSubtitle = styled.p`
  font-size: 16px;
  color: #6B7280;
  margin: 0;
  margin-top: 4px;
  font-family: 'Inter', system-ui, sans-serif;
`;

export const NanoPageDescription = styled.p`
  font-size: 14px;
  color: #D97706;
  margin: 0;
  margin-top: 4px;
  font-family: 'Inter', system-ui, sans-serif;
`;

// Responsive container for header content
export const NanoHeaderContent = styled.div`
  display: flex;
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  align-items: ${props => props.isMobile ? 'flex-start' : 'center'};
  justify-content: space-between;
  gap: 16px;
`;

// Controls container
export const NanoControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// Stat card styling (reusing existing pattern)
export const NanoStatCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

// Chart container styling
export const NanoChartContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
`;

// Loading skeleton styling
export const NanoLoadingSkeleton = styled.div`
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`; 